export default "__VITE_ASSET__D$EocfTI__"